// extracted by mini-css-extract-plugin
module.exports = {"flexColumnGap":"styles_flexColumnGap__b9GM2","priceRangeBox":"styles_priceRangeBox__jVZvm"};